import { endpointHandler } from '../../endpoints';
const { activePrivacyNoticeEndpoint } = endpointHandler();

export const activePrivacyNoticeAPI = (reqConfig, urlVar) => {
  return activePrivacyNoticeEndpoint.get(reqConfig, urlVar);
};
